module.exports = __webpack_public_path__ + "static/media/fast.bfe7a8b0.svg";